<!-- eslint-disable @angular-eslint/template/elements-content -->
@if (!hidden()) {
  <button
    class="toggle {{ `size-${size()}` }}"
    [class.active]="checked()"
    [class.disabled]="disabled()"
    [class.invalid]="isInvalid()"
    type="button"
    [disabled]="disabled()"
    [tabindex]="disabled() ? -1 : 0"
    (focusout)="touch.emit()"
    #toggleElement
  ></button>

  @let control = formField() ?? formControl();
  @if (label(); as label) {
    <onyx-input-label
      variant="title"
      [label]="label"
      [required]="!!control && required() && showRequired()"
      [disabled]="disabled()"
    ></onyx-input-label>
  }

  @if (control && showErrors()) {
    <onyx-error [errors]="[control]"></onyx-error>
  }
}
